'use strict';

angular.module('atex.art').factory('ArtListOptions', function() {
  return {
    listOptions:{
      searchText: '',
      sortField: 'dateModified',
      reverseSort: true
    }
  };
});
